
import { defineComponent, onMounted, inject, ref } from "vue";
import type { Ref } from "vue";

import SectionHeader from "@/components/Shared/SectionHeader/SectionHeader.vue";
import WorkItems from "@/components/SelectedWork/WorkItems/WorkItems.vue";
import WorkModal from "@/components/SelectedWork/WorkModal/WorkModal.vue";
import { updateActiveLinkOnScroll } from "@/components/FixedNav/animate";
import { ActiveLinkContext } from "@/interfaces/nav";
import { Work } from "@/interfaces/work";

export default defineComponent({
  name: "Work",
  components: {
    SectionHeader,
    WorkItems,
    WorkModal,
  },
  setup() {
    const { updateActiveLink } = inject("active-link") as ActiveLinkContext;

    const isOpen: Ref<boolean> = ref(false);
    const activeWork: Ref<Work | null> = ref(null);

    const updateModal = (value: boolean, work: Work | null) => {
      isOpen.value = value;
      activeWork.value = work;
    };

    onMounted(() =>
      updateActiveLinkOnScroll("#selected-work", updateActiveLink)
    );

    return {
      isOpen,
      activeWork,
      updateModal,
    };
  },
});
